import { Settings } from "@mui/icons-material";
import theme from "theme";
import { ManagementCard } from "routes/lenses/lens/admin/management/ManagementCard";

interface CaseProfileExportBuilderProps {
  onClick: () => void;
}

const CaseProfileExportBuilder = ({ onClick }: CaseProfileExportBuilderProps) => {
  return (
    <ManagementCard
      title="Case Profile Exports"
      onClick={onClick}
      Icon={Settings}
      color={theme.palette.primary.main}
      id="lens-admin-management-configure-profile-export"
    />
  );
};

export default CaseProfileExportBuilder;
